import lazyLoading from './lazyLoading';
import Vue from 'vue';

export default {
  name: 'Accounts',
  meta: {
    expanded: false,
    title: 'menu.accounts',
    iconClass: 'entypo entypo-key',
  },
  children: [
    {
      name: 'myself',
      path: '/accounts/myself',
      component: lazyLoading('accounts/UserForm'),
      meta: {
        title: 'menu.myself',
        iconClass: 'vuestic-icon vuestic-icon-user',
        to: '/accounts/myself',
        auth: true,
      },
      props: r => ({root: true, value: 'me'}),
    },
    {
      name: 'users',
      path: '/accounts/users/:id?',
      component: lazyLoading('accounts/Users'),
      meta: {
        title: 'schema.users',
        iconClass: 'vuestic-icon vuestic-icon-user',
        to: '/accounts/users',
        auth: 'admin',
      },
      props: r => ({root: true, id: r.params.id}),
    },
    {
      name: 'profiles',
      path: '/accounts/profiles/:id?',
      component: lazyLoading('accounts/Profiles'),
      meta: {
        title: 'schema.profiles',
        iconClass: 'entypo entypo-vcard',
        to: '/accounts/profiles',
        auth: 'admin',
        debug: true,
      },
      props: r => ({root: true, id: r.params.id}),
    },
    {
      name: 'profiles.landlord',
      path: '/accounts/profiles.landlord/:id?',
      component: lazyLoading('accounts/Profiles'),
      meta: {
        title: 'roles.landlord',
        iconClass: 'entypo entypo-vcard',
        to: '/accounts/profiles.landlord',
        auth: 'admin',
        debug: true,
      },
      props: r => ({
        root: true,
        id: r.params.id,
        title: Vue.i18n.translate('roles.landlord'),
        appendParams: {filter: {role: 'landlord'}},
      }),
    },
    {
      name: 'profiles.driver',
      path: '/accounts/profiles.driver/:id?',
      component: lazyLoading('accounts/Profiles'),
      meta: {
        title: 'roles.driver',
        iconClass: 'entypo entypo-vcard',
        to: '/accounts/profiles.driver',
        auth: 'admin',
        debug: true,
      },
      props: r => ({
        root: true,
        id: r.params.id,
        title: Vue.i18n.translate('roles.driver'),
        appendParams: {filter: {role: 'driver'}},
      }),
    },
    // {
    //   name: 'ec_groups',
    //   path: '/accounts/groups/:id?',
    //   component: lazyLoading('ecommerce/EC_Groups'),
    //   meta: {
    //     title: 'schema.ec_groups',
    //     iconClass: 'entypo entypo-users',
    //     to: '/accounts/groups',
    //   },
    //   props: r => ({root: true, id: r.params.id}),
    // },
  ],
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/accounts.js